import { setOpacity } from "@memorang/helpers/setOpacity";
import { useState } from "react";
import { Pressable } from "react-native";
import { Searchbar, type SearchbarProps } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

export type CustomSearchbarProps = SearchbarProps & {
	useBorder?: boolean;
};

const CustomSearchbar = ({
	useBorder = true,
	...props
}: CustomSearchbarProps) => {
	const theme = useAppTheme();
	const [isHovered, setIsHovered] = useState(false);
	const [isFocused, setIsFocused] = useState(false);
	return (
		<Pressable
			onHoverIn={() => setIsHovered(true)}
			onHoverOut={() => setIsHovered(false)}
		>
			<Searchbar
				{...props}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				mode="bar"
				icon={() => null}
				style={[
					{
						backgroundColor:
							isHovered && !props.value && !isFocused
								? setOpacity(theme.colors.onSurface, 0.12)
								: theme.colors.elevation.level2,
						borderWidth: useBorder && props.value ? 2 : 0,
						borderColor:
							useBorder && props.value ? theme.colors.primary : undefined,
					},
					props.style,
				]}
				inputStyle={[
					{
						marginLeft: props.icon ? 0 : -30,
					},
					props.inputStyle,
				]}
				placeholderTextColor={theme.colors.onSurfaceVariant}
			/>
		</Pressable>
	);
};

export default CustomSearchbar;
